// extracted by mini-css-extract-plugin
export default {"section":"App_section__bVdvb","layout":"App_layout__NIXtc"};